import * as React from "react";
import { useState } from "react";
import { styled } from "@mui/material/styles";
import Avatar from "@mui/material/Avatar";
import MuiDrawer, { drawerClasses } from "@mui/material/Drawer";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import MenuContent from "./MenuContent";
import CustomDatePicker from "./CustomDatePicker";
import ColorModeIconDropdown from "../../shared-theme/ColorModeIconDropdown";
import OptionsMenu from "./OptionsMenu";
import MenuIcon from "@mui/icons-material/Menu";
import IconButton from "@mui/material/IconButton";

const drawerWidth = 205;
const collapsedWidth = 65;

const StyledDrawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: open ? drawerWidth : collapsedWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  transition: theme.transitions.create(["width", "background-color"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.standard,
  }),

  [`& .${drawerClasses.paper}`]: {
    width: open ? drawerWidth : collapsedWidth,
    overflowX: "hidden",
    backgroundColor: theme.palette.background.paper,
    transition: theme.transitions.create(["width", "background-color"], {
      easing: theme.transitions.easing.easeInOut,
      duration: theme.transitions.duration.standard,
    }),
    borderRight: `1px solid ${theme.palette.divider}`,
  },
}));

export default function SideMenu() {
  const [open, setOpen] = useState(true);

  const toggleDrawer = () => {
    setOpen(!open);
  };

  return (
    <>
      <StyledDrawer
        variant="permanent"
        open={open}
        sx={{
          display: { xs: "none", md: "block" },
          position: "relative",
        }}
      >
        {/* Header */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: open ? "space-between" : "center",
            px: 1.5,
            py: 2,
            gap: 1,
          }}
        >
          {open && <CustomDatePicker />}
          {open && <ColorModeIconDropdown />}
          <IconButton onClick={toggleDrawer} size="small">
            <MenuIcon />
          </IconButton>
        </Box>

        <Divider />
        <MenuContent />
        <Divider />

        <Stack
          direction="row"
          sx={{
            position: "fixed",
            bottom: 0,
            left: 0,
            width: "10%",
            p: 1,
            gap: 2,
            alignItems: "center",
            zIndex: 10,
            backgroundColor: "background.paper",
            borderTop: "1px solid #ddd",
          }}
        >
          <Avatar
            sizes="small"
            alt="Riley Carter"
            sx={{
              width: 30,
              height: 30,
              marginLeft: 1,
              transition: "all 0.3s ease",
            }}
          />
          {open && (
            <Box sx={{ mr: "auto" }}>
              <Typography
                variant="body2"
                sx={{ fontWeight: 500, lineHeight: "12px", marginRight: 5 }}
              >
                {localStorage.getItem("name")?.toUpperCase()}
              </Typography>
            </Box>
          )}
          <OptionsMenu />
        </Stack>
      </StyledDrawer>
    </>
  );
}
